import { css } from 'styled-components';

/**
 * Mixin for using text ellipsis on single line text displays.
 */
export const ellipsisTextMixin = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

/**
 * Mixin for using gradient colored text.
 */
export const gradientTextMixin = (gradient: string, alternate: string) => css`
  color: ${alternate};

  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    background: ${gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

/**
 * Mixin that can be included to hide scrollbars for an element.
 */
export const hideScrollbarMixin = css`
  /* Disable scrollbar in webkit browsers */
  &::-webkit-scrollbar {
    display: none;
  }
  // Disable scrollbars in other browsers
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
